import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "393884608964";

export const WhatsAppFab = () => {
  if (!WHATSAPP_NUMBER) return null;
  return (
    <motion.a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi TapeShift Weddings! We'd love to talk about our wedding.")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with TapeShift on WhatsApp"
      data-testid="whatsapp-chat-btn"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 2.2, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#C9A26B] text-[#0A0A0A] flex items-center justify-center shadow-[0_0_30px_rgba(201,162,107,0.35)]"
    >
      <MessageCircle className="w-6 h-6" fill="currentColor" />
    </motion.a>
  );
};
